import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  logo: {
    fill: theme.palette.common.white,
    height: '40px',
    width: '114px',
    flex: '0 0 auto',
    margin: '0 2px',
  },
  logoAbsolute: {
    marginBottom: 30,
    [theme.breakpoints.up('sm')]: {
      position: 'absolute',
      marginBottom: 0,
      top: '20px',
      left: '20px',
    },
  },
  primary: {
    fill: theme.palette.primary.main,
  },
}));

const FinmoLogo = ({ absolute, primary }) => {
  const classes = useStyles();

  return (
    <svg
      className={clsx(classes.logo, {
        [classes.logoAbsolute]: absolute,
        [classes.primary]: primary,
      })}
      viewBox="0 0 114 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Logo">
        <g id="Finmo 2">
          <path
            id="Finmo"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M68.8233 17.9814H65.941V15.3584H68.8233V17.9814ZM53.4495 15.4681H63.8717V18.0512H56.5013V21.4322H62.9541V23.9854H56.5013V30.1489H53.4495V15.4681ZM68.8233 19.2779H65.941V30.1489H68.8233V19.2779ZM77.8041 19.0186C78.9278 19.0186 79.847 19.3128 80.5618 19.9013C81.2765 20.4897 81.6339 21.4654 81.6339 22.8284V30.1489H78.7217V23.5366C78.7217 22.9647 78.6452 22.5259 78.4923 22.2201C78.213 21.6616 77.6811 21.3823 76.8965 21.3823C75.9324 21.3823 75.2709 21.7912 74.9118 22.609C74.7257 23.0412 74.6326 23.5931 74.6326 24.2646V30.1489H71.8001V19.2979H74.5428V20.8836C74.9085 20.3251 75.2542 19.9229 75.58 19.6769C76.1652 19.238 76.9065 19.0186 77.8041 19.0186ZM98.025 19.3178C97.5596 19.1316 97.0875 19.0386 96.6088 19.0386C95.8907 19.0386 95.2391 19.1882 94.654 19.4874C94.1021 19.7866 93.64 20.2553 93.2677 20.8936C93.0549 20.3617 92.7424 19.9262 92.3302 19.5871C91.8182 19.2214 91.1467 19.0386 90.3156 19.0386C89.4379 19.0386 88.7231 19.2513 88.1713 19.6769C87.8588 19.9162 87.5263 20.3185 87.1739 20.8836V19.2979H84.4113V30.1489H87.2936V23.6064C87.2936 23.0146 87.3701 22.5691 87.523 22.2699C87.8023 21.7447 88.3475 21.482 89.1586 21.482C89.8568 21.482 90.3255 21.7447 90.5649 22.2699C90.6979 22.5625 90.7644 23.0312 90.7644 23.6762V30.1489H93.6267V23.6762C93.6267 23.1908 93.7032 22.7753 93.8561 22.4295C94.1553 21.7779 94.6972 21.4521 95.4818 21.4521C96.16 21.4521 96.6254 21.7048 96.8781 22.2101C97.011 22.4761 97.0775 22.8151 97.0775 23.2274V30.1489H99.9898L100.01 23.2972C100.01 22.5924 99.9765 22.0572 99.91 21.6915C99.8036 21.1396 99.5975 20.6742 99.2916 20.2952C98.9126 19.8298 98.4904 19.504 98.025 19.3178ZM107.704 28.1443C108.535 28.1443 109.173 27.8484 109.619 27.2566C110.064 26.6649 110.287 25.8238 110.287 24.7334C110.287 23.6429 110.064 22.8035 109.619 22.2151C109.173 21.6266 108.535 21.3324 107.704 21.3324C106.873 21.3324 106.233 21.6266 105.784 22.2151C105.335 22.8035 105.111 23.6429 105.111 24.7334C105.111 25.8238 105.335 26.6649 105.784 27.2566C106.233 27.8484 106.873 28.1443 107.704 28.1443ZM111.893 28.8274C112.81 27.6938 113.269 26.3291 113.269 24.7334C113.269 23.1642 112.81 21.8045 111.893 20.6542C110.975 19.504 109.582 18.9288 107.714 18.9288C105.846 18.9288 104.453 19.504 103.535 20.6542C102.618 21.8045 102.159 23.1642 102.159 24.7334C102.159 26.3291 102.618 27.6938 103.535 28.8274C104.453 29.9611 105.846 30.5279 107.714 30.5279C109.582 30.5279 110.975 29.9611 111.893 28.8274Z"
          />
        </g>
        <g id="Group 2">
          <g id="Group Copy">
            <path
              id="Combined Shape"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.1484 9.67034C19.1484 15.0111 14.8619 19.3407 9.57422 19.3407C8.14785 19.3407 6.79434 19.0256 5.57816 18.4607C5.32133 19.653 5.18604 20.8911 5.18604 22.1612C5.18604 31.7301 12.8661 39.4872 22.3399 39.4872C31.8136 39.4872 39.4937 31.7301 39.4937 22.1612C39.4937 12.5923 31.8136 4.83517 22.3399 4.83517C20.8929 4.83517 19.4878 5.01612 18.1456 5.35683C18.7874 6.65541 19.1484 8.12028 19.1484 9.67034Z"
            />
          </g>
          <g id="Group Copy 2">
            <path
              id="Combined Shape_2"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.57816 18.4607C6.96081 12.0418 11.8658 6.95083 18.1456 5.35682C16.576 2.18111 13.3273 0 9.57422 0C4.28653 0 0 4.32955 0 9.67033C0 13.5704 2.28584 16.9313 5.57816 18.4607Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

FinmoLogo.propTypes = {
  absolute: PropTypes.bool,
  primary: PropTypes.bool,
};

FinmoLogo.defaultProps = {
  absolute: false,
  primary: false,
};

export default FinmoLogo;
